import UdeskLocales from 'UdeskLocales';
import { useMemo } from 'react';
import { RuleTypeMap } from '../const';

interface UseOptionsProps {}

export const useOptions = (props?: UseOptionsProps) => {
    const options = useMemo(
        () => [
            {
                value: RuleTypeMap.ALL,
                label: UdeskLocales['current'].pages.tasks.manage.template.checkPoint.configuration
                    .logic.all,
            },
            {
                value: RuleTypeMap.ANY,
                label: UdeskLocales['current'].pages.tasks.manage.template.checkPoint.configuration
                    .logic.any,
            },
            {
                value: RuleTypeMap.CUSTOMIZE,
                label: UdeskLocales['current'].pages.tasks.manage.template.checkPoint.configuration
                    .logic.customize,
            },
        ],
        []
    );

    return { options };
};
